import DarkModeIcon from "@/assets/icons/ModeDark.svg?react";
import LightModeIcon from "@/assets/icons/ModeLight.svg?react";
import { Button, useTheme } from "@st-marketplace/ui";

export default function ThemeMenu() {
	const { resolvedTheme, setTheme } = useTheme();
	const isDarkMode = resolvedTheme === "dark";
	const ModeIcon = isDarkMode ? DarkModeIcon : LightModeIcon;

	return (
		<Button
			type="button"
			color="ghost"
			size="md"
			icon
			className="rounded-lg"
			onClick={() => setTheme(isDarkMode ? "light" : "dark")}
			aria-label={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
			title={`Switch to ${isDarkMode ? "light" : "dark"} mode`}
		>
			<ModeIcon className="size-5" />
		</Button>
	);
}
